import { MapLocationIcon, StreetLocationIcon } from '@repo/icons';
import type { MapType } from '@repo/map';
import type { TestId } from '@repo/test-id';
import { Button } from '@repo/ui';

interface Props {
  mapType: MapType;
  onChange: (mapType: MapType) => void;
  testId: TestId;
  className?: string;
}

export default function MapTypeButton({ mapType, onChange, testId, className }: Props) {
  const nextMapType: MapType = mapType === 'roadmap' ? 'satellite' : 'roadmap';
  const icon = mapType === 'roadmap' ? StreetLocationIcon : MapLocationIcon;
  const testIdAddon = nextMapType === 'satellite' ? 'setToSatelliteMap' : 'setToRoadMap';

  const handleClick = (): void => {
    onChange(nextMapType);
  };

  return (
    <Button
      color="tertiary"
      size="lg"
      iconOnly
      className={className}
      leftIcon={icon}
      onClick={handleClick}
      testId={testId.append(testIdAddon)}
    />
  );
}
